// AI-CONTEXT: See docs/features/msi-rekenregels-monetarisering.md
import calculateParticipationImpact from './calculateParticipationImpact'
import { currentParticipationContext } from './birthDatesByPersona'
import resolveInterventionDose from '../msiMonetisationHelpers/resolveInterventionDose'
import toMillis from '../measurementSignals/toMillis'

// De huidige stand van één deelnemer op de participatieladder (beginsituatie →
// huidige situatie), met de looptijd van de MSI-rekenregels. Nodig omdat de
// kaart, de detailpagina en de nachtrun hetzelfde getal moeten geven: eerder
// rekende elk zijn eigen kopie. Eind van een traject zonder einddatum = de
// laatste bewerking van de huidige situatie (besluit R3).
//
// Spiegel: functions/participationHelpers/currentLadderImpact.js, bewaakt door
// currentLadderImpact.parity.test.js.

/**
 * @param {object} input
 * @param {{ID?: string, Participation?: {t0?: object, t1?: object}}} input.persona
 * @param {object} input.parameters - Rekenparameters van de participatieladder
 * @param {Object<string, string>|null} [input.birthDates] - PersonaID → geboortedatum (leeftijdsovergang 2026.3)
 * @param {{ Months?: *, HoursPerWeek?: * }|null} [input.orgDefault] - CompagnyMeta.DefaultInterventionDose
 * @returns {{impact: object, dose: import('../msiMonetisationHelpers/resolveInterventionDose').InterventionDose}|null} null zonder huidige situatie
 */
const currentLadderImpact = ({ persona, parameters, birthDates = null, orgDefault = null }) => {
    const participation = persona?.Participation || {}
    const current = participation.t1 || {}
    if (!current.mainActivity) return null
    const dose = resolveInterventionDose({ persona, lastMeasurementMs: toMillis(current.updatedAt), orgDefault })
    const impact = calculateParticipationImpact({
        participantProfileT0: participation.t0 || {},
        participantProfileT1: current,
        parameters,
        context: currentParticipationContext(persona, birthDates),
        horizon: dose.horizon,
    })
    return { impact, dose }
}

export default currentLadderImpact
